class DataManager {
  constructor() {
    this.maxSize = 50;
    this.data = {};
  }

  addData(service, serviceItem, request, response) {
    if(!this.data[service]) {
      this.data[service] = {};
    }
    if (!this.data[service][serviceItem]) {
      this.data[service][serviceItem] = [];
    }
    if (this.data[service][serviceItem].length >= this.maxSize) {
      this.data[service][serviceItem].shift(); // Remove the oldest entry if max size reached
    }
    this.data[service][serviceItem].push({ request, response });
  }

  getDataForService(service) {
    return this.data[service] || [];
  }

  getAllData() {
    return this.data;
  }

  clearDataForService(service) {
    this.data[service] = [];
  }

  clearAllData() {
    this.data = {};
  }
}

export default DataManager;